import { qs, qsa } from "../inc/dom.js";

const initVirtualTours = () => {
    const items = qsa("[data-vt-item]");
    if (!items.length) return;
    const buttons = qsa("[data-vt-filter]");
    const select = qs("[data-vt-select]");
    const search = qs("[data-vt-search]");
    const form = qs("[data-vt-searchform]");
    const empty = qs("[data-vt-empty]");

    let tag = "";
    let term = "";

    const matches = (item) => {
        if (tag && !(item.dataset.vtTags || "").split(" ").includes(tag)) return false;
        if (term && !(item.dataset.vtName || "").includes(term)) return false;
        return true;
    };

    const render = () => {
        let shown = 0;
        items.forEach((item) => {
            const visible = matches(item);
            item.hidden = !visible;
            if (visible) shown += 1;
        });
        if (empty) empty.hidden = shown !== 0;
        buttons.forEach((button) => {
            button.classList.toggle("is-active", button.dataset.vtFilter === tag);
        });
        if (select && select.value !== tag) select.value = tag;
    };

    buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            tag = button.dataset.vtFilter || "";
            render();
        });
    });

    if (select) {
        select.addEventListener("change", () => {
            tag = select.value;
            render();
        });
    }

    if (form) form.addEventListener("submit", (event) => event.preventDefault());

    if (search) {
        search.addEventListener("input", () => {
            term = search.value.trim().toLowerCase();
            render();
        });
    }

    render();
};

initVirtualTours();
